import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AppDispatch } from '@store/types';
import { pushMessage } from '@reducers/v2/messagesBus/messagesBus.slice';
import { ProductionInformationMessageType } from '@reducers/v2/messagesBus/types';

export const addedProductionInformationMessageProducer = createAsyncThunk<void, Record<string, unknown>, { dispatch: AppDispatch }>(
  'details/addedProductionInformationMessageProducer',
  async (e, { dispatch }) => {
    const ncFileId = (e?.clampingDetails as Record<string, unknown>)?.ncFileId as string | undefined;
    if (ncFileId == null) return;

    dispatch(
      pushMessage({
        key: ncFileId,
        message: { messageType: ProductionInformationMessageType.ADDED_PRODUCTION_INFORMATION, payload: e },
      })
    );
  }
);
